import React, { useState } from 'react';
import { RowHeight } from '../../object-table.interface';
import { PrimaryContentComponent } from './components/primary-content.component';
import { PrimaryExtendedContentComponent } from './components/primary-extended-content.component';
import styles from './primary-column.module.scss';
export const PrimaryColumn = React.memo(({ data, colDef }) => {
    const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'primary'];
    const primaryColumn = {
        ...fieldValues,
    };
    const [rowHeight, setRowHeight] = useState(RowHeight.Default);
    const onMoreClick = () => {
        setRowHeight(RowHeight.Extended);
    };
    return (React.createElement("div", { className: styles.primaryColumnContainer, "data-testid": "primary-column-testid" },
        rowHeight === RowHeight.Extended && (React.createElement(PrimaryExtendedContentComponent, { primaryUrl: primaryColumn.primaryUrl, primaryText: primaryColumn.primaryText, primaryTextOnClick: primaryColumn.primaryTextOnClick, secondaryText: primaryColumn.secondaryText })),
        rowHeight !== RowHeight.Extended && (React.createElement(PrimaryContentComponent, { primaryUrl: primaryColumn.primaryUrl, primaryText: primaryColumn.primaryText, primaryTextOnClick: primaryColumn.primaryTextOnClick, secondaryText: primaryColumn.secondaryText, onMoreClick: onMoreClick, rowHeight: rowHeight, setRowHeight: setRowHeight }))));
});
//# sourceMappingURL=primary-column.js.map